export type Language = 'fi' | 'en' | 'sv' | 'th';

export const languages: Language[] = ['fi', 'en', 'sv', 'th'];

export const languageNames: Record<Language, string> = {
  fi: 'Suomi',
  en: 'English',
  sv: 'Svenska',
  th: 'ไทย',
};

export const translations = {
  fi: {
    nav: {
      home: 'Etusivu',
      services: 'Palvelut',
      contact: 'Yhteystiedot',
      portfolio: 'Portfolio',
      menu: 'Valikko',
    },
    game: {
      title: 'Haiko-Tetris',
      start: 'Aloita peli',
      restart: 'Pelaa uudelleen',
      paused: 'Tauko',
      pauseHint: 'Paina P jatkaaksesi',
      gameOver: 'Peli päättyi',
      pressSpace: 'tai paina välilyöntiä',
      playAndWin: 'Pelaa ja voita -20% alennus!',
      breakRecord: 'Riko ennätys → saat kuponkikoodin',
    },
    score: {
      score: 'Pisteet',
      level: 'Taso',
      lines: 'Rivit',
      record: 'Ennätys',
      recordDate: 'Tehty',
      nextPiece: 'Seuraava',
    },
    controls: {
      move: 'Siirrä',
      rotate: 'Käännä',
      down: 'Alas',
      drop: 'Pudota',
      pause: 'Tauko',
    },
    cta: {
      title: '🎮 Pelaa & voita!',
      description: 'Riko ennätys ja saat',
      discount: '-20%',
      suffix: 'alennuskoodin Haiko Innovations -palveluihin.',
      termsTitle: 'Ehdot',
      terms: [
        'Kuponki vain uudesta ennätyksestä',
        'Voimassa 14 päivää',
        'Yksi koodi per ennätys',
        'Ei yhdistettävissä muihin tarjouksiin',
      ],
    },
    mobileScore: {
      score: 'Pisteet',
      level: 'Taso',
      record: 'Ennätys',
    },
    footer: {
      rights: 'Kaikki oikeudet pidätetään.',
      privacy: 'Tietosuoja',
      terms: 'Käyttöehdot',
      cookies: 'Evästeet',
    },
    newsletter: {
      title: '🚀 Pysy innovaatioiden aallonharjalla',
      description: 'Tilaa uutiskirjeemme ja saat ensimmäisenä tietoa uusista palveluista, teknologioista ja tarjouksista.',
      placeholder: 'sähköpostisi@esim.fi',
      gdpr: 'Hyväksyn tietojen käsittelyn',
      gdprLink: 'tietosuojaselosteen',
      gdprSuffix: ' mukaisesti.',
      subscribe: 'Tilaa',
      success: 'Kiitos tilauksesta! 🎉',
      error: 'Jokin meni pieleen, yritä uudelleen.',
      alreadySubscribed: 'Olet jo tilaajalistallamme!',
    },
    specialOffer: '🎉 Erikoistarjous',
    modal: {
      newRecord: 'Uusi ennätys!',
      points: 'pistettä',
      discountCode: 'Alennuskoodisi -20%',
      copyOrEmail: 'Kopioi koodi tai vastaanota se sähköpostiisi:',
      copy: 'Kopioi koodi leikepöydälle',
      copied: 'Kopioitu!',
      marketingConsent: 'Hyväksyn, että sähköpostiosoitettani voidaan käyttää markkinointiviestintään.',
      privacyPolicy: 'Tietosuojaseloste',
      emailPlaceholder: 'sähköpostisi@esim.fi',
      sendEmail: 'Lähetä koodi sähköpostiin',
      emailSent: 'Koodi lähetetty osoitteeseen',
      validDays: 'Koodi on voimassa 14 päivää. Yksi koodi per ennätys.',
      useDiscount: 'Käytä alennuksesi!',
      useDiscountDesc: 'Ota yhteyttä ja liitä kuponkikoodisi',
      useDiscountSuffix: 'viestikenttään — saat -20% alennuksen!',
      specialOfferTitle: '🎉 Erikoistarjous',
      specialOfferPrice: 'Nettisivut 500 €',
      specialOfferMaintenance: 'ylläpito vain 5 €/kk',
      specialOfferDesc: 'Ammattimaiset verkkosivut kiinteään hintaan. Sisältää suunnittelun, toteutuksen ja oman domainin!',
      readMore: 'Lue lisää erikoistarjouksesta →',
      serviceCore: 'Haiko Core – IT-konsultointi',
      serviceCoreDesc: 'Selkeät ratkaisut liiketoimintasi tueksi',
      serviceFlow: 'Haiko Flow – Ohjelmistokehitys',
      serviceFlowDesc: 'Sujuvat ja kestävät digitaaliset ratkaisut',
      serviceTrust: 'Haiko Trust – Kyberturvallisuus',
      serviceTrustDesc: 'Eettinen hakkerointi ja tietoturvatestaus',
      contactUs: 'Ota yhteyttä',
      exploreServices: 'Tutustu palveluihin →',
    },
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      contact: 'Contact',
      portfolio: 'Portfolio',
      menu: 'Menu',
    },
    game: {
      title: 'Haiko-Tetris',
      start: 'Start Game',
      restart: 'Play Again',
      paused: 'Paused',
      pauseHint: 'Press P to continue',
      gameOver: 'Game Over',
      pressSpace: 'or press spacebar',
      playAndWin: 'Play and win -20% discount!',
      breakRecord: 'Break the record → get a coupon code',
    },
    score: {
      score: 'Score',
      level: 'Level',
      lines: 'Lines',
      record: 'Record',
      recordDate: 'Set on',
      nextPiece: 'Next',
    },
    controls: {
      move: 'Move',
      rotate: 'Rotate',
      down: 'Down',
      drop: 'Drop',
      pause: 'Pause',
    },
    cta: {
      title: '🎮 Play & Win!',
      description: 'Break the record and get a',
      discount: '-20%',
      suffix: 'discount code for Haiko Innovations services.',
      termsTitle: 'Terms',
      terms: [
        'Coupon only for new record',
        'Valid for 14 days',
        'One code per record',
        'Cannot be combined with other offers',
      ],
    },
    mobileScore: {
      score: 'Score',
      level: 'Level',
      record: 'Record',
    },
    footer: {
      rights: 'All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      cookies: 'Cookies',
    },
    newsletter: {
      title: '🚀 Stay ahead of innovation',
      description: 'Subscribe to our newsletter and be the first to hear about new services, technologies and offers.',
      placeholder: 'your@email.com',
      gdpr: 'I accept the processing of my data per the',
      gdprLink: 'privacy policy',
      gdprSuffix: '.',
      subscribe: 'Subscribe',
      success: 'Thanks for subscribing! 🎉',
      error: 'Something went wrong, please try again.',
      alreadySubscribed: 'You are already on our list!',
    },
    specialOffer: '🎉 Special Offer',
    modal: {
      newRecord: 'New Record!',
      points: 'points',
      discountCode: 'Your -20% discount code',
      copyOrEmail: 'Copy the code or receive it by email:',
      copy: 'Copy code to clipboard',
      copied: 'Copied!',
      marketingConsent: 'I agree that my email address can be used for marketing communications.',
      privacyPolicy: 'Privacy Policy',
      emailPlaceholder: 'your@email.com',
      sendEmail: 'Send code to email',
      emailSent: 'Code sent to',
      validDays: 'Code is valid for 14 days. One code per record.',
      useDiscount: 'Use your discount!',
      useDiscountDesc: 'Contact us and include your coupon code',
      useDiscountSuffix: 'in the message field — get -20% off!',
      specialOfferTitle: '🎉 Special Offer',
      specialOfferPrice: 'Websites €500',
      specialOfferMaintenance: 'maintenance only €5/mo',
      specialOfferDesc: 'Professional websites at a fixed price. Includes design, development and your own domain!',
      readMore: 'Learn more about the offer →',
      serviceCore: 'Haiko Core – IT Consulting',
      serviceCoreDesc: 'Clear solutions to support your business',
      serviceFlow: 'Haiko Flow – Software Development',
      serviceFlowDesc: 'Smooth and sustainable digital solutions',
      serviceTrust: 'Haiko Trust – Cybersecurity',
      serviceTrustDesc: 'Ethical hacking and security testing',
      contactUs: 'Contact us',
      exploreServices: 'Explore services →',
    },
  },
  sv: {
    nav: {
      home: 'Hem',
      services: 'Tjänster',
      contact: 'Kontakt',
      portfolio: 'Portfolio',
      menu: 'Meny',
    },
    game: {
      title: 'Haiko-Tetris',
      start: 'Starta spel',
      restart: 'Spela igen',
      paused: 'Paus',
      pauseHint: 'Tryck P för att fortsätta',
      gameOver: 'Spelet slut',
      pressSpace: 'eller tryck mellanslag',
      playAndWin: 'Spela och vinn -20% rabatt!',
      breakRecord: 'Slå rekordet → få en kupongkod',
    },
    score: {
      score: 'Poäng',
      level: 'Nivå',
      lines: 'Rader',
      record: 'Rekord',
      recordDate: 'Satt den',
      nextPiece: 'Nästa',
    },
    controls: {
      move: 'Flytta',
      rotate: 'Rotera',
      down: 'Ner',
      drop: 'Släpp',
      pause: 'Paus',
    },
    cta: {
      title: '🎮 Spela & vinn!',
      description: 'Slå rekordet och få en',
      discount: '-20%',
      suffix: 'rabattkod för Haiko Innovations tjänster.',
      termsTitle: 'Villkor',
      terms: [
        'Kupong bara för nytt rekord',
        'Giltig i 14 dagar',
        'En kod per rekord',
        'Kan inte kombineras med andra erbjudanden',
      ],
    },
    mobileScore: {
      score: 'Poäng',
      level: 'Nivå',
      record: 'Rekord',
    },
    footer: {
      rights: 'Alla rättigheter förbehållna.',
      privacy: 'Integritetspolicy',
      terms: 'Användarvillkor',
      cookies: 'Cookies',
    },
    newsletter: {
      title: '🚀 Håll dig i framkant',
      description: 'Prenumerera på vårt nyhetsbrev och få först veta om nya tjänster, teknologier och erbjudanden.',
      placeholder: 'din@epost.se',
      gdpr: 'Jag godkänner databehandling enligt',
      gdprLink: 'integritetspolicyn',
      gdprSuffix: '.',
      subscribe: 'Prenumerera',
      success: 'Tack för din prenumeration! 🎉',
      error: 'Något gick fel, försök igen.',
      alreadySubscribed: 'Du finns redan på vår lista!',
    },
    specialOffer: '🎉 Specialerbjudande',
    modal: {
      newRecord: 'Nytt rekord!',
      points: 'poäng',
      discountCode: 'Din -20% rabattkod',
      copyOrEmail: 'Kopiera koden eller ta emot den via e-post:',
      copy: 'Kopiera koden till urklipp',
      copied: 'Kopierad!',
      marketingConsent: 'Jag godkänner att min e-postadress kan användas för marknadsföringskommunikation.',
      privacyPolicy: 'Integritetspolicy',
      emailPlaceholder: 'din@epost.se',
      sendEmail: 'Skicka koden till e-post',
      emailSent: 'Koden skickad till',
      validDays: 'Koden gäller i 14 dagar. En kod per rekord.',
      useDiscount: 'Använd din rabatt!',
      useDiscountDesc: 'Kontakta oss och inkludera din kupongkod',
      useDiscountSuffix: 'i meddelandefältet — få -20% rabatt!',
      specialOfferTitle: '🎉 Specialerbjudande',
      specialOfferPrice: 'Hemsidor 500 €',
      specialOfferMaintenance: 'underhåll bara 5 €/mån',
      specialOfferDesc: 'Professionella hemsidor till fast pris. Inkluderar design, utveckling och egen domän!',
      readMore: 'Läs mer om erbjudandet →',
      serviceCore: 'Haiko Core – IT-konsulting',
      serviceCoreDesc: 'Tydliga lösningar för din verksamhet',
      serviceFlow: 'Haiko Flow – Mjukvaruutveckling',
      serviceFlowDesc: 'Smidiga och hållbara digitala lösningar',
      serviceTrust: 'Haiko Trust – Cybersäkerhet',
      serviceTrustDesc: 'Etisk hacking och säkerhetstestning',
      contactUs: 'Kontakta oss',
      exploreServices: 'Utforska tjänster →',
    },
  },
  th: {
    nav: {
      home: 'หน้าแรก',
      services: 'บริการ',
      contact: 'ติดต่อ',
      portfolio: 'ผลงาน',
      menu: 'เมนู',
    },
    game: {
      title: 'Haiko-Tetris',
      start: 'เริ่มเกม',
      restart: 'เล่นอีกครั้ง',
      paused: 'หยุดชั่วคราว',
      pauseHint: 'กด P เพื่อเล่นต่อ',
      gameOver: 'เกมจบ',
      pressSpace: 'หรือกด Space bar',
      playAndWin: 'เล่นและรับส่วนลด -20%!',
      breakRecord: 'ทำลายสถิติ → รับโค้ดคูปอง',
    },
    score: {
      score: 'คะแนน',
      level: 'ระดับ',
      lines: 'แถว',
      record: 'สถิติ',
      recordDate: 'ทำเมื่อ',
      nextPiece: 'ถัดไป',
    },
    controls: {
      move: 'เลื่อน',
      rotate: 'หมุน',
      down: 'ลง',
      drop: 'ทิ้ง',
      pause: 'หยุด',
    },
    cta: {
      title: '🎮 เล่นและชนะ!',
      description: 'ทำลายสถิติและรับ',
      discount: '-20%',
      suffix: 'โค้ดส่วนลดสำหรับบริการ Haiko Innovations',
      termsTitle: 'เงื่อนไข',
      terms: [
        'คูปองสำหรับสถิติใหม่เท่านั้น',
        'ใช้ได้ 14 วัน',
        'หนึ่งโค้ดต่อสถิติ',
        'ไม่สามารถใช้ร่วมกับข้อเสนออื่น',
      ],
    },
    mobileScore: {
      score: 'คะแนน',
      level: 'ระดับ',
      record: 'สถิติ',
    },
    footer: {
      rights: 'สงวนลิขสิทธิ์',
      privacy: 'นโยบายความเป็นส่วนตัว',
      terms: 'ข้อกำหนดการใช้งาน',
      cookies: 'คุกกี้',
    },
    newsletter: {
      title: '🚀 ก้าวนำหน้านวัตกรรม',
      description: 'สมัครรับจดหมายข่าวของเราและเป็นคนแรกที่ทราบเกี่ยวกับบริการ เทคโนโลยี และข้อเสนอใหม่ๆ',
      placeholder: 'your@email.com',
      gdpr: 'ฉันยอมรับการประมวลผลข้อมูลตาม',
      gdprLink: 'นโยบายความเป็นส่วนตัว',
      gdprSuffix: '',
      subscribe: 'สมัคร',
      success: 'ขอบคุณที่สมัคร! 🎉',
      error: 'เกิดข้อผิดพลาด กรุณาลองอีกครั้ง',
      alreadySubscribed: 'คุณอยู่ในรายชื่อของเราแล้ว!',
    },
    specialOffer: '🎉 ข้อเสนอพิเศษ',
    modal: {
      newRecord: 'สถิติใหม่!',
      points: 'คะแนน',
      discountCode: 'โค้ดส่วนลด -20% ของคุณ',
      copyOrEmail: 'คัดลอกโค้ดหรือรับทางอีเมล:',
      copy: 'คัดลอกโค้ด',
      copied: 'คัดลอกแล้ว!',
      marketingConsent: 'ฉันยินยอมให้ใช้อีเมลเพื่อการสื่อสารทางการตลาด',
      privacyPolicy: 'นโยบายความเป็นส่วนตัว',
      emailPlaceholder: 'your@email.com',
      sendEmail: 'ส่งโค้ดทางอีเมล',
      emailSent: 'ส่งโค้ดไปที่',
      validDays: 'โค้ดใช้ได้ 14 วัน หนึ่งโค้ดต่อสถิติ',
      useDiscount: 'ใช้ส่วนลดของคุณ!',
      useDiscountDesc: 'ติดต่อเราและแนบโค้ดคูปอง',
      useDiscountSuffix: 'ในช่องข้อความ — รับส่วนลด -20%!',
      specialOfferTitle: '🎉 ข้อเสนอพิเศษ',
      specialOfferPrice: 'เว็บไซต์ €500',
      specialOfferMaintenance: 'ดูแลเพียง €5/เดือน',
      specialOfferDesc: 'เว็บไซต์มืออาชีพในราคาคงที่ รวมการออกแบบ พัฒนา และโดเมนของคุณ!',
      readMore: 'อ่านเพิ่มเติมเกี่ยวกับข้อเสนอ →',
      serviceCore: 'Haiko Core – IT Consulting',
      serviceCoreDesc: 'โซลูชันที่ชัดเจนเพื่อสนับสนุนธุรกิจของคุณ',
      serviceFlow: 'Haiko Flow – Software Development',
      serviceFlowDesc: 'โซลูชันดิจิทัลที่ราบรื่นและยั่งยืน',
      serviceTrust: 'Haiko Trust – Cybersecurity',
      serviceTrustDesc: 'การแฮ็กอย่างมีจริยธรรมและการทดสอบความปลอดภัย',
      contactUs: 'ติดต่อเรา',
      exploreServices: 'สำรวจบริการ →',
    },
  },
} as const;

export function getTranslation(lang: Language) {
  return translations[lang];
}

export function detectLanguage(): Language {
  if (typeof window === 'undefined') return 'fi';
  
  // Check URL parameter first (for cross-domain sync)
  const urlParams = new URLSearchParams(window.location.search);
  const urlLang = urlParams.get('lang') as Language;
  if (urlLang && languages.includes(urlLang)) {
    localStorage.setItem('haiko-language', urlLang);
    return urlLang;
  }
  
  const stored = localStorage.getItem('haiko-language') as Language;
  if (stored && languages.includes(stored)) return stored;
  const browserLang = navigator.language.split('-')[0] as Language;
  if (languages.includes(browserLang)) return browserLang;
  return 'fi';
}

export function setLanguage(lang: Language) {
  localStorage.setItem('haiko-language', lang);
}
